import React from 'react'

interface Props {
  onClick?: () => void
  className?: string
}

const ExpandIcon: React.FC<Props> = ({ onClick, className }) => (
  <svg
    width="21"
    height="24"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    className={className}
  >
    <rect
      x="21"
      y="24"
      width="9"
      height="3"
      transform="rotate(180 21 24)"
      fill="#8D8D8D"
    />
    <rect
      x="21"
      y="17"
      width="9"
      height="3"
      transform="rotate(180 21 17)"
      fill="#8D8D8D"
    />
    <rect
      x="21"
      y="10"
      width="9"
      height="3"
      transform="rotate(180 21 10)"
      fill="#8D8D8D"
    />
    <rect
      x="21"
      y="3"
      width="9"
      height="3"
      transform="rotate(180 21 3)"
      fill="#8D8D8D"
    />
    <path d="M8 12L2 15.4641L2 8.5359L8 12Z" fill="#8D8D8D" />
  </svg>
)

export default ExpandIcon
